module.exports = __webpack_public_path__ + "static/media/15.2b10e406.jpg";